import React, { useEffect, useState } from 'react';
import Styles from '../styles/components/SelectWorshipService.module.css';

const SelectWorshipService = ({ onSelect, services }) => {
    const [error, setError] = useState('');

    if (error) return <p className={Styles.error}>{error}</p>;
    if (!services.length) return <p className={Styles.message}>No services found.</p>;

    return (
        <div className={Styles.container}>
            <h2>Select a Service</h2>
            <ul className={Styles.serviceList}>
                {services.length > 0 && services.map(service => (
                    <li key={service.service_id} className={Styles.serviceItem}>
                        <button onClick={() => onSelect(service)} className={Styles.selectButton}>
                            {service.service_date} {service.hymn_leader && `– ${service.hymn_leader}`}
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default SelectWorshipService;
